import React from 'react';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { useCultureSectionController } from './CultureSection.controllers';
import { DesktopContainer, StyledColumns, StyledColumn, StyledBox, AssetWrapper, StyledCloudImage } from './CultureSection.styles';
import { useTranslation } from 'react-i18next';

export const CultureSectionDesktop: React.FC = () => {
  const { t } = useTranslation('careers');
  const cultureData = t('culture');

  const { containerRef, impactAssetRef, buildAssetRef, funAseetRef } = useCultureSectionController();
  const items = [
    {
      ...cultureData.items[0],
      assetRef: impactAssetRef,
    },
    {
      ...cultureData.items[1],
      assetRef: buildAssetRef,
    },
    {
      ...cultureData.items[2],
      assetRef: funAseetRef,
    },
  ];

  return (
    <DesktopContainer ref={containerRef} paddingTop={12} paddingBottom={13}>
      <TextPairing
        eyebrow={cultureData.eyebrow}
        eyebrowVariant="sectionEyeBrow24"
        eyebrowColor={'humana5'}
        eyebrowTagName="h3"
        title={cultureData.title}
        titleVariant="hed72Hero"
        titleColor={'neutra6'}
        titleTagName="h2"
        textAlign="center"
        alignment={'center'}
      />
      <Box marginTop={10}>
        <StyledColumns multiline stackOnMobile={false}>
          <StyledColumn width={5}>
            {items.map((item, index) => (
              <StyledBox key={index}>
                <TextPairing
                  title={item.title}
                  titleVariant="calloutHed32"
                  titleColor="neutra6"
                  titleTagName="h3"
                  body={item.body}
                  bodyVariant="dek20"
                  bodyColor="neutra5"
                  textAlign={'left'}
                />
              </StyledBox>
            ))}
          </StyledColumn>
          <StyledColumn width={7}>
            {items.map((itemAsset, index) => (
              <AssetWrapper ref={itemAsset.assetRef} key={index}>
                <StyledCloudImage src={itemAsset.image} width="100%" />
              </AssetWrapper>
            ))}
          </StyledColumn>
        </StyledColumns>
      </Box>
    </DesktopContainer>
  );
};
